/**
 * Screen names, button names, button locations, and list names
 * Matches iOS ScreenName.swift exactly
 */

/**
 * Screen name enum for tracking screen views
 */
export enum ScreenName {
  LOGIN = 'login_screen',
  OTP = 'otp_screen',
  MORE = 'more_screen',
  LANGUAGE_PICKER = 'language_picker_screen',
  STORE_PICKER = 'store_picker_screen',
  SITES = 'sites_screen',
  SITE_DETAILS = 'site_details_screen',
  HOME = 'home_screen', // Added for web home page
  PRODUCTS = 'products_screen', // Added for web products page
}

/**
 * List name enum for tracking list-related events
 */
export enum ListName {
  SITES = 'sites_list',
  STORES = 'stores_list',
  LANGUAGES = 'languages_list',
  CHALLANS = 'challans_list',
  RATE_TYPE_LIST = 'rate_types_list',
}

/**
 * Button name enum for tracking button clicks
 */
export enum ButtonName {
  MOBILE_LOGIN = 'mobile_login_button',
  SUBMIT_OTP = 'submit_otp_button',
  LOGOUT = 'logout_button',
  LOGOUT_CONFIRM = 'logout_confirm_button',
  LOGOUT_CANCEL = 'logout_cancel_button',
  LANGUAGE_CONTINUE = 'language_continue_button',
  STORE_PICKER_CONTINUE = 'store_picker_continue_button',
  SITES_REFRESH = 'sites_refresh_button',
  SITES_SORT = 'sites_sort_button',
  ADD_SITE = 'add_site_button',
  SITE_ISSUE_ITEMS = 'site_issue_items_button',
  SITE_RECEIVE_ITEMS = 'site_receive_items_button',
  SITE_LOST_ITEMS = 'site_lost_items_button',
  SITE_MORE_ACTIONS = 'site_more_actions_button',
  PARTY_WHATSAPP = 'party_whatsapp_button',
  PARTY_CALL = 'party_call_button',
  PARTY_NEW_SITE = 'party_new_site_button',
  NEW_CHALLAN = 'new_challan_button',
  CHALLANS_MORE_ACTIONS = 'challans_more_actions_button',
  CHALLANS_REFRESH = 'challans_refresh_button',
  SUM_ENTRIES_SWITCH = 'sum_entries_switch',
  CHALLAN_SHARE = 'share_selected_button',
  ALL_CHALLAN_SHARE = 'share_all_button',
  CHALLAN_EDIT = 'challan_edit_button',
  CHALLAN_DELETE = 'challan_delete_button',
  ENTRY_MORE = 'entry_more_button',
  ENTRY_EDIT = 'entry_edit_button',
  ENTRY_DELETE = 'entry_delete_button',
  // Web-specific button names
  WHATSAPP_DEMO = 'whatsapp_demo_button',
  WATCH_DEMO_VIDEOS = 'watch_demo_videos_button',
  START_FREE_TRIAL = 'start_free_trial_button',
  ANDROID_APP = 'android_app_button',
  IPHONE_APP = 'iphone_app_button',
  LOGIN = 'login_button',
  CONTACT_US = 'contact_us_button',
  DEVICE_LAPTOP = 'device_laptop_button',
  DEVICE_ANDROID = 'device_android_button',
  DEVICE_IPHONE = 'device_iphone_button',
  DEVICE_TABLET = 'device_tablet_button',
  WEB_APP = 'web_app_button',
}

/**
 * Button location enum for tracking where buttons are located
 */
export enum ButtonLocation {
  PRIMARY = 'primary',
  TOP = 'top',
  BOTTOM = 'bottom',
  HEADER = 'header',
  LIST_ITEM = 'list_item',
  HERO = 'hero', // Added for web home page hero section
  DEVICES = 'devices', // Added for devices section interactions
}

